import {StyleSheet } from '@react-pdf/renderer';

export const  styles = StyleSheet.create({
    section: {
        fontWeight: 'bold',
        marginTop: 15, 
    },
    textHeaderBolded: {
        fontFamily: "Arial",
        fontWeight: 'bold',
        fontSize : 11,
        margin: 2,
        backgroundColor: "#e6e6e6"
    },
    textHeader: {
        fontFamily: "Arial",
        fontWeight: 'bold',
        fontSize : 10,
        margin: 2,
        textAlign: "center"
    },
    sousSection: {
        paddingRight: 20,
        paddingLeft: 20,
        paddingTop : 20,
        fontSize : 11,
        fontFamily: 'Arial'
    },
    title: {
        fontSize: 15,
        textAlign: 'center',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontFamily: 'Arial'
    },
    subtitle1: {
        fontWeight: 'semibold',
        fontFamily: 'Arial',
        textDecoration: 'underline',
        fontSize: 13,
        margin: 2,
    },
    subtitle2: {
        fontWeight: 'semibold',
        fontFamily: 'Arial',
        textDecoration: 'underline',
        fontSize: 12,
        margin: 2,
    },
    subtitle3: {
        fontFamily: 'Arial',
        textDecoration: 'underline',
        fontSize: 12,
        margin: 2,
    },
    textBolded: {
        fontFamily: "Arial",
        fontWeight: 'bold',
        fontSize : 11,
        margin: 2,
    },
    text: {
        fontFamily: "Arial",
        fontSize: 11,
        margin: 2,
    },
    image: { 
        position: 'absolute',
        minWidth: '100%',
        minHeight: '100%',
        height: '100%',
        width: '100%',
    },
    page: {
        flexDirection: 'column'
    },
    containerBlock:{ 
        marginLeft : 50 ,
        marginTop: 70
    },
});